import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withKeys as _withKeys, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "sset" }
const _hoisted_2 = {
  class: "sset__hero",
  "data-tour": "seller-settle-summary"
}
const _hoisted_3 = { class: "sui-card sset__payout" }
const _hoisted_4 = { class: "sui-table-wrap" }
const _hoisted_5 = { class: "sui-table sset__sum" }
const _hoisted_6 = { class: "is-num" }
const _hoisted_7 = { class: "is-num" }
const _hoisted_8 = { class: "is-num" }
const _hoisted_9 = { class: "is-num" }
const _hoisted_10 = { class: "is-total" }
const _hoisted_11 = { class: "is-num" }
const _hoisted_12 = { class: "is-num" }
const _hoisted_13 = { class: "sset__meta" }
const _hoisted_14 = {
  key: 0,
  class: "sset__cta"
}
const _hoisted_15 = {
  class: "sui-card sset__howto",
  "data-tour": "seller-settle-howto"
}
const _hoisted_16 = { class: "sui-card__body" }
const _hoisted_17 = { class: "sset__steps" }
const _hoisted_18 = {
  class: "sui-card sui-card--flush sset__board",
  "data-tour": "seller-settle-list"
}
const _hoisted_19 = { class: "sset__sticky" }
const _hoisted_20 = {
  class: "sset__filters",
  "data-tour": "seller-settle-filters",
  "aria-label": "정산 화면"
}
const _hoisted_21 = {
  key: 0,
  class: "sset__list-count"
}
const _hoisted_22 = {
  key: 1,
  class: "sset__list-count"
}
const _hoisted_23 = {
  class: "sui-toolbar",
  "data-tour": "seller-settle-toolbar"
}
const _hoisted_24 = ["value"]
const _hoisted_25 = { class: "sui-search" }
const _hoisted_26 = ["placeholder"]
const _hoisted_27 = ["disabled"]
const _hoisted_28 = {
  key: 0,
  class: "sset__bulk"
}
const _hoisted_29 = ["disabled"]
const _hoisted_30 = ["disabled"]
const _hoisted_31 = {
  key: 1,
  class: "sset__done"
}
const _hoisted_32 = {
  key: 2,
  class: "sset__error"
}
const _hoisted_33 = { class: "sset__scroll" }
const _hoisted_34 = {
  key: 0,
  class: "sui-table-wrap"
}
const _hoisted_35 = { class: "sui-table sset__table" }
const _hoisted_36 = { class: "sset__check" }
const _hoisted_37 = ["checked", ".indeterminate"]
const _hoisted_38 = ["onClick"]
const _hoisted_39 = { class: "sset__check" }
const _hoisted_40 = ["checked", "aria-label", "onClick"]
const _hoisted_41 = { class: "sui-table__strong" }
const _hoisted_42 = { class: "sui-table__sub" }
const _hoisted_43 = { class: "is-num" }
const _hoisted_44 = { class: "is-num sset__minus" }
const _hoisted_45 = { class: "is-num" }
const _hoisted_46 = { class: "is-num" }
const _hoisted_47 = { class: "is-num sui-table__strong" }
const _hoisted_48 = {
  key: 1,
  class: "sui-table-wrap"
}
const _hoisted_49 = { class: "sui-table sset__table" }
const _hoisted_50 = ["onClick"]
const _hoisted_51 = { class: "sui-table__strong" }
const _hoisted_52 = { class: "sui-table__sub" }
const _hoisted_53 = { class: "is-num" }
const _hoisted_54 = { class: "is-num sui-table__strong" }
const _hoisted_55 = {
  key: 0,
  class: "sui-badge"
}
const _hoisted_56 = {
  key: 1,
  class: "sui-badge sui-badge--green"
}
const _hoisted_57 = {
  key: 2,
  class: "sui-badge sui-badge--amber"
}
const _hoisted_58 = {
  key: 3,
  class: "sui-table__sub"
}
const _hoisted_59 = { class: "sset__actions" }
const _hoisted_60 = ["onClick"]
const _hoisted_61 = ["onClick"]
const _hoisted_62 = ["disabled", "onClick"]
const _hoisted_63 = {
  key: 0,
  class: "sset__bundle-row"
}
const _hoisted_64 = { colspan: "5" }
const _hoisted_65 = { class: "sset__lines" }
const _hoisted_66 = { class: "sui-table__strong" }
const _hoisted_67 = { class: "sui-table__sub" }
const _hoisted_68 = { class: "is-num" }
const _hoisted_69 = { class: "is-num sset__minus" }
const _hoisted_70 = { class: "is-num" }
const _hoisted_71 = { class: "is-num" }
const _hoisted_72 = {
  key: 2,
  class: "sui-empty"
}

import { computed, onMounted, reactive, ref } from 'vue'
import AppIcon from '@/components/common/AppIcon.vue'
import { confirmDialog } from '@/composables/useConfirmDialog'
import { useSellerAuth } from '@/composables/useSellerAuth'
import { formatWon } from '@/constants/sellerData'
import {
  cancelSellerSettlementRequest,
  createSellerSettlementRequest,
  downloadSellerSettlementRequestExcel,
  fetchSellerSettlementBoard,
  type AdminSettlementItem,
  type SettlementRequest,
} from '@/api/mallOrder'


export default /*@__PURE__*/_defineComponent({
  __name: 'SellerSettlementsPage',
  setup(__props) {

const { policy } = useSellerAuth()

const view = ref<'eligible' | 'requests'>('eligible')
const eligible = ref<AdminSettlementItem[]>([])
const requests = ref<SettlementRequest[]>([])
const availableCount = ref(0)
const availableSum = ref(0)
const requestedCount = ref(0)
const requestedSum = ref(0)
const paidCount = ref(0)
const paidSum = ref(0)
const period = ref('')
const keyword = ref('')
const loading = ref(false)
const busy = ref(false)
const errorMessage = ref('')
const successMessage = ref('')
const opened = ref(0)
const selected = reactive(new Set<number>())

function formatPeriodLabel(value: string) {
  const [year, month] = value.split('-')
  if (!year || !month) return value
  return `${year}년 ${Number(month)}월`
}

const periodOptions = computed(() => {
  const options: { value: string; label: string }[] = []
  const now = new Date()
  for (let i = 0; i < 18; i += 1) {
    const date = new Date(now.getFullYear(), now.getMonth() - i, 1)
    const value = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`
    options.push({ value, label: `${formatPeriodLabel(value)} 구매확정분` })
  }
  return options
})

const hasAccount = computed(() => Boolean(policy.value.settleBank && policy.value.settleAccount))

const payoutAccount = computed(() => {
  const { settleBank, settleAccount } = policy.value
  if (!settleBank || !settleAccount) return '미등록'
  const masked = `${settleAccount.slice(0, 4)}${'*'.repeat(Math.max(0, settleAccount.length - 8))}${settleAccount.slice(-4)}`
  return `${settleBank} ${masked}`
})

const selectedRows = computed(() => eligible.value.filter((row) => selected.has(row.itemIdx)))
const selectedCount = computed(() => selectedRows.value.length)
const selectedPayout = computed(() =>
  selectedRows.value.reduce((sum, row) => sum + Number(row.payout || 0), 0),
)
const allSelected = computed(
  () => eligible.value.length > 0 && eligible.value.every((row) => selected.has(row.itemIdx)),
)
const someSelected = computed(() => eligible.value.some((row) => selected.has(row.itemIdx)))

function formatDateTime(value: string | null | undefined) {
  if (!value) return '—'
  const text = String(value).replace('T', ' ')
  return text.length >= 16 ? text.slice(0, 16) : text
}

function toggle(itemIdx: number) {
  if (selected.has(itemIdx)) selected.delete(itemIdx)
  else selected.add(itemIdx)
}

function toggleAll(checked: boolean) {
  if (checked) eligible.value.forEach((row) => selected.add(row.itemIdx))
  else eligible.value.forEach((row) => selected.delete(row.itemIdx))
}

function toggleBundle(id: number) {
  opened.value = opened.value === id ? 0 : id
}

function clearSelection() {
  selected.clear()
}

function pruneSelection() {
  const alive = new Set(eligible.value.map((row) => row.itemIdx))
  ;[...selected].forEach((idx) => {
    if (!alive.has(idx)) selected.delete(idx)
  })
}

async function reload() {
  loading.value = true
  errorMessage.value = ''
  successMessage.value = ''
  try {
    const result = await fetchSellerSettlementBoard({
      period: period.value || undefined,
      keyword: keyword.value || undefined,
    })
    eligible.value = result.eligible || []
    requests.value = result.requests || []
    availableCount.value = Number(result.availableCount || 0)
    availableSum.value = Number(result.availableSum || 0)
    requestedCount.value = Number(result.requestedCount || 0)
    requestedSum.value = Number(result.requestedSum || 0)
    paidCount.value = Number(result.paidCount || 0)
    paidSum.value = Number(result.paidSum || 0)
    pruneSelection()
  } catch (error) {
    errorMessage.value = error instanceof Error ? error.message : '정산 내역을 불러오지 못했습니다.'
    eligible.value = []
    requests.value = []
  } finally {
    loading.value = false
  }
}

async function onRequest() {
  if (busy.value || !selectedCount.value) return
  if (!hasAccount.value) {
    errorMessage.value = '정산 계좌를 먼저 등록해 주세요.'
    return
  }
  const ok = await confirmDialog({
    title: '정산 신청',
    message: `선택한 ${selectedCount.value}건을 하나의 정산 신청으로 묶을까요?`,
    detail: `지급액 ${formatWon(selectedPayout.value)}원\n신청 후 정산신청내역에서 묶음으로 확인할 수 있습니다.`,
    confirmLabel: '정산 신청',
    tone: 'primary',
  })
  if (!ok) return
  busy.value = true
  errorMessage.value = ''
  try {
    const result = await createSellerSettlementRequest(selectedRows.value.map((row) => row.itemIdx))
    clearSelection()
    view.value = 'requests'
    await reload()
    successMessage.value = result.message
  } catch (error) {
    errorMessage.value = error instanceof Error ? error.message : '정산 신청에 실패했습니다.'
  } finally {
    busy.value = false
  }
}

async function onCancel(request: SettlementRequest) {
  const ok = await confirmDialog({
    title: '신청 취소',
    message: '이 정산 신청을 취소할까요? 포함된 건은 다시 정산 가능 목록으로 돌아갑니다.',
    detail: request.title,
    confirmLabel: '신청 취소',
    tone: 'danger',
  })
  if (!ok) return
  busy.value = true
  try {
    await cancelSellerSettlementRequest(request.id)
    await reload()
  } catch (error) {
    errorMessage.value = error instanceof Error ? error.message : '요청 취소에 실패했습니다.'
  } finally {
    busy.value = false
  }
}

async function onExcel(request: SettlementRequest) {
  try {
    await downloadSellerSettlementRequestExcel(request)
  } catch (error) {
    errorMessage.value = error instanceof Error ? error.message : '엑셀을 내려받지 못했습니다.'
  }
}

onMounted(reload)

const steps = [
  {
    title: '구매확정된 건만',
    desc: '배송이 끝난 뒤 고객이 구매확정하거나, 배송완료 7일이 지나면 정산 가능 목록에 올라옵니다.',
  },
  {
    title: '건을 골라 신청',
    desc: '하나씩 고르거나, 기간·검색으로 좁힌 뒤 검색 결과 전체를 선택해 한 묶음으로 신청합니다.',
  },
  {
    title: '관리자가 완료',
    desc: '정산신청내역에서 묶음과 포함 건을 확인합니다. 관리자가 정산하고 완료를 누르면 그 신청은 끝납니다.',
  },
]

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("article", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("table", _hoisted_5, [
            _cache[10] || (_cache[10] = _createElementVNode("caption", null, "정산 현황", -1)),
            _cache[11] || (_cache[11] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, "범위"),
                _createElementVNode("th", null, "구분"),
                _createElementVNode("th", { class: "is-num" }, "건수"),
                _createElementVNode("th", { class: "is-num" }, "지급액")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _cache[6] || (_cache[6] = _createElementVNode("td", {
                  class: "sset__sum-period",
                  rowspan: "3"
                }, "전체", -1)),
                _cache[7] || (_cache[7] = _createElementVNode("th", null, "정산 가능", -1)),
                _createElementVNode("td", _hoisted_6, _toDisplayString(availableCount.value) + "건", 1),
                _createElementVNode("td", _hoisted_7, _toDisplayString(_unref(formatWon)(availableSum.value)) + "원", 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[8] || (_cache[8] = _createElementVNode("th", null, "신청 중", -1)),
                _createElementVNode("td", _hoisted_8, _toDisplayString(requestedCount.value) + "묶음", 1),
                _createElementVNode("td", _hoisted_9, _toDisplayString(_unref(formatWon)(requestedSum.value)) + "원", 1)
              ]),
              _createElementVNode("tr", _hoisted_10, [
                _cache[9] || (_cache[9] = _createElementVNode("th", null, "완료", -1)),
                _createElementVNode("td", _hoisted_11, _toDisplayString(paidCount.value) + "묶음", 1),
                _createElementVNode("td", _hoisted_12, _toDisplayString(_unref(formatWon)(paidSum.value)) + "원", 1)
              ])
            ])
          ])
        ]),
        _createElementVNode("p", _hoisted_13, [
          _createElementVNode("span", null, [
            _cache[12] || (_cache[12] = _createTextVNode(" 입금 계좌 ", -1)),
            _createElementVNode("strong", {
              class: _normalizeClass({ 'is-warn': !hasAccount.value })
            }, _toDisplayString(payoutAccount.value), 3)
          ])
        ]),
        (!hasAccount.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_14, [
              _createVNode(_component_router_link, {
                to: "/seller/settings",
                class: "sui-btn sui-btn--sm sui-btn--primary"
              }, {
                default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                  _createTextVNode(" 정산 계좌 등록하기 ", -1)
                ]))]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("article", _hoisted_15, [
        _cache[14] || (_cache[14] = _createElementVNode("div", { class: "sui-card__head" }, [
          _createElementVNode("h2", { class: "sui-card__title" }, "정산 흐름")
        ], -1)),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("ol", _hoisted_17, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(steps, (step, index) => {
              return _createElementVNode("li", {
                key: step.title
              }, [
                _createElementVNode("em", null, _toDisplayString(index + 1), 1),
                _createElementVNode("div", null, [
                  _createElementVNode("strong", null, _toDisplayString(step.title), 1),
                  _createElementVNode("p", null, _toDisplayString(step.desc), 1)
                ])
              ])
            }), 64))
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("nav", _hoisted_20, [
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["sset__filter", { 'is-active': view.value === 'eligible', 'is-alert': availableCount.value > 0 }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (view.value = 'eligible'))
          }, [...(_cache[15] || (_cache[15] = [
            _createElementVNode("span", { class: "sset__filter-label" }, "정산 가능", -1)
          ]))], 2),
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["sset__filter", { 'is-active': view.value === 'requests' }]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (view.value = 'requests'))
          }, [...(_cache[16] || (_cache[16] = [
            _createElementVNode("span", { class: "sset__filter-label" }, "정산신청내역", -1)
          ]))], 2),
          _cache[17] || (_cache[17] = _createElementVNode("span", { class: "sset__filters-spacer" }, null, -1)),
          (view.value === 'eligible')
            ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(eligible.value.length) + "건", 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(requests.value.length) + "묶음", 1))
        ]),
        _createElementVNode("div", _hoisted_23, [
          (view.value === 'eligible')
            ? _withDirectives((_openBlock(), _createElementBlock("select", {
                key: 0,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((period).value = $event)),
                class: "sui-select sset__period",
                "aria-label": "구매확정 연월",
                onChange: reload
              }, [
                _cache[18] || (_cache[18] = _createElementVNode("option", { value: "" }, "전체 기간 (구매확정일 기준)", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(periodOptions.value, (option) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: option.value,
                    value: option.value
                  }, _toDisplayString(option.label), 9, _hoisted_24))
                }), 128))
              ], 544)), [
                [_vModelSelect, period.value]
              ])
            : _createCommentVNode("", true),
          _createElementVNode("label", _hoisted_25, [
            _createVNode(AppIcon, {
              icon: "mdi-magnify",
              size: 17
            }),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((keyword).value = $event)),
              type: "search",
              placeholder: view.value === 'eligible' ? '주문번호 · 상품 검색' : '신청 이름 · 주문번호 · 상품',
              onKeyup: _withKeys(reload, ["enter"])
            }, null, 40, _hoisted_26), [
              [
                _vModelText,
                keyword.value,
                void 0,
                { trim: true }
              ]
            ])
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "sui-btn",
            disabled: loading.value,
            onClick: reload
          }, [
            _createVNode(AppIcon, {
              icon: "mdi-magnify",
              size: 16
            }),
            _cache[19] || (_cache[19] = _createTextVNode(" 검색 ", -1))
          ], 8, _hoisted_27)
        ]),
        (view.value === 'eligible' && eligible.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
              _createElementVNode("button", {
                type: "button",
                class: "sui-btn",
                disabled: busy.value,
                onClick: _cache[4] || (_cache[4] = ($event: any) => (toggleAll(!allSelected.value)))
              }, _toDisplayString(allSelected.value ? '선택 해제' : '검색 결과 전체 선택'), 9, _hoisted_29),
              _createElementVNode("strong", null, _toDisplayString(selectedCount.value) + "건 선택", 1),
              _createElementVNode("span", null, "지급액 " + _toDisplayString(_unref(formatWon)(selectedPayout.value)) + "원", 1),
              _cache[20] || (_cache[20] = _createElementVNode("span", { class: "sset__bulk-spacer" }, null, -1)),
              _createElementVNode("button", {
                type: "button",
                class: "sui-btn sui-btn--primary",
                disabled: busy.value || !selectedCount.value || !hasAccount.value,
                onClick: onRequest
              }, _toDisplayString(busy.value ? '신청 중…' : '정산 신청'), 9, _hoisted_30)
            ]))
          : _createCommentVNode("", true),
        (successMessage.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_31, _toDisplayString(successMessage.value), 1))
          : _createCommentVNode("", true),
        (errorMessage.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_32, [
              _createVNode(AppIcon, {
                icon: "mdi-alert-outline",
                size: 16
              }),
              _createTextVNode(" " + _toDisplayString(errorMessage.value), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_33, [
        (view.value === 'eligible' && eligible.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
              _createElementVNode("table", _hoisted_35, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", _hoisted_36, [
                      _createElementVNode("input", {
                        type: "checkbox",
                        checked: allSelected.value,
                        ".indeterminate": someSelected.value && !allSelected.value,
                        "aria-label": "검색 결과 전체 선택",
                        onChange: _cache[5] || (_cache[5] = ($event: any) => (toggleAll(($event.target as HTMLInputElement).checked)))
                      }, null, 40, _hoisted_37)
                    ]),
                    _cache[21] || (_cache[21] = _createElementVNode("th", null, "주문번호", -1)),
                    _cache[22] || (_cache[22] = _createElementVNode("th", { class: "is-num" }, "판매대금", -1)),
                    _cache[23] || (_cache[23] = _createElementVNode("th", { class: "is-num" }, "함우리 수수료", -1)),
                    _cache[24] || (_cache[24] = _createElementVNode("th", { class: "is-num" }, "판매업체 마진", -1)),
                    _cache[25] || (_cache[25] = _createElementVNode("th", { class: "is-num" }, "배송비", -1)),
                    _cache[26] || (_cache[26] = _createElementVNode("th", { class: "is-num" }, "지급액", -1)),
                    _cache[27] || (_cache[27] = _createElementVNode("th", null, "구매확정", -1))
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(eligible.value, (row) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: row.itemIdx,
                      class: _normalizeClass({ 'is-checked': selected.has(row.itemIdx) }),
                      onClick: ($event: any) => (toggle(row.itemIdx))
                    }, [
                      _createElementVNode("td", _hoisted_39, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          checked: selected.has(row.itemIdx),
                          "aria-label": `${row.orderCode} 선택`,
                          onClick: _withModifiers(($event: any) => (toggle(row.itemIdx)), ["stop","prevent"])
                        }, null, 8, _hoisted_40)
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("span", _hoisted_41, _toDisplayString(row.orderCode), 1),
                        _createElementVNode("span", _hoisted_42, [
                          _createTextVNode(_toDisplayString(row.productName) + " ", 1),
                          (row.optionLabel)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(" · " + _toDisplayString(row.optionLabel), 1)
                              ], 64))
                            : _createCommentVNode("", true),
                          _createTextVNode(" · " + _toDisplayString(row.qty) + _toDisplayString(row.unit || '개') + " ", 1),
                          (row.lineKind === 'RETURN_FEE')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(" · 단순 변심 반품비")
                              ], 64))
                            : (row.lineKind === 'SHIPPING')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                  _createTextVNode(" · 출고 배송비")
                                ], 64))
                              : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_43, _toDisplayString(_unref(formatWon)(row.salesAmount)) + "원", 1),
                      _createElementVNode("td", _hoisted_44, "-" + _toDisplayString(_unref(formatWon)(row.platformFee)) + "원", 1),
                      _createElementVNode("td", _hoisted_45, _toDisplayString(_unref(formatWon)(row.sellerMargin)) + "원", 1),
                      _createElementVNode("td", _hoisted_46, _toDisplayString(_unref(formatWon)(row.shippingFee || 0)) + "원", 1),
                      _createElementVNode("td", _hoisted_47, _toDisplayString(_unref(formatWon)(row.payout)) + "원", 1),
                      _createElementVNode("td", null, _toDisplayString(row.lineKind === 'RETURN_FEE' ? '변심 반품비' : row.lineKind === 'SHIPPING' ? '출고 배송비' : formatDateTime(row.confirmedAt)), 1)
                    ], 10, _hoisted_38))
                  }), 128))
                ])
              ])
            ]))
          : (view.value === 'requests' && requests.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                _createElementVNode("table", _hoisted_49, [
                  _cache[29] || (_cache[29] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, "요청"),
                      _createElementVNode("th", { class: "is-num" }, "건수"),
                      _createElementVNode("th", { class: "is-num" }, "지급액"),
                      _createElementVNode("th", null, "상태"),
                      _createElementVNode("th")
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(requests.value, (request) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: request.id
                      }, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", null, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "sset__bundle",
                              onClick: ($event: any) => (toggleBundle(request.id))
                            }, [
                              _createElementVNode("span", _hoisted_51, _toDisplayString(request.title), 1),
                              _createElementVNode("span", _hoisted_52, _toDisplayString(formatDateTime(request.requestedAt)), 1)
                            ], 8, _hoisted_50)
                          ]),
                          _createElementVNode("td", _hoisted_53, _toDisplayString(request.count) + "건", 1),
                          _createElementVNode("td", _hoisted_54, _toDisplayString(_unref(formatWon)(request.payout)) + "원", 1),
                          _createElementVNode("td", null, [
                            (request.kind === 'LEGACY')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_55, "이전 정산"))
                              : (request.status === 'PAID')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_56, "완료"))
                                : (_openBlock(), _createElementBlock("span", _hoisted_57, "신청")),
                            (request.paidAt)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_58, _toDisplayString(formatDateTime(request.paidAt)), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", _hoisted_59, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "sui-btn sui-btn--sm",
                              onClick: ($event: any) => (toggleBundle(request.id))
                            }, _toDisplayString(opened.value === request.id ? '접기' : '건별 보기'), 9, _hoisted_60),
                            _createElementVNode("button", {
                              type: "button",
                              class: "sui-btn sui-btn--sm",
                              onClick: ($event: any) => (onExcel(request))
                            }, "엑셀", 8, _hoisted_61),
                            (request.kind !== 'LEGACY' && request.status === 'REQUESTED')
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  type: "button",
                                  class: "sui-btn sui-btn--sm",
                                  disabled: busy.value,
                                  onClick: ($event: any) => (onCancel(request))
                                }, " 신청 취소 ", 8, _hoisted_62))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        (opened.value === request.id)
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_63, [
                              _createElementVNode("td", _hoisted_64, [
                                _createElementVNode("table", _hoisted_65, [
                                  _cache[28] || (_cache[28] = _createElementVNode("thead", null, [
                                    _createElementVNode("tr", null, [
                                      _createElementVNode("th", null, "주문번호"),
                                      _createElementVNode("th", { class: "is-num" }, "판매대금"),
                                      _createElementVNode("th", { class: "is-num" }, "수수료"),
                                      _createElementVNode("th", { class: "is-num" }, "배송비"),
                                      _createElementVNode("th", { class: "is-num" }, "지급액")
                                    ])
                                  ], -1)),
                                  _createElementVNode("tbody", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(request.items, (item) => {
                                      return (_openBlock(), _createElementBlock("tr", {
                                        key: item.id
                                      }, [
                                        _createElementVNode("td", null, [
                                          _createElementVNode("span", _hoisted_66, _toDisplayString(item.orderCode), 1),
                                          _createElementVNode("span", _hoisted_67, [
                                            _createTextVNode(_toDisplayString(item.productName) + " ", 1),
                                            (item.optionLabel)
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                  _createTextVNode(" · " + _toDisplayString(item.optionLabel), 1)
                                                ], 64))
                                              : _createCommentVNode("", true),
                                            _createTextVNode(" · " + _toDisplayString(item.qty) + _toDisplayString(item.unit || '개'), 1)
                                          ])
                                        ]),
                                        _createElementVNode("td", _hoisted_68, _toDisplayString(_unref(formatWon)(item.salesAmount)) + "원", 1),
                                        _createElementVNode("td", _hoisted_69, "-" + _toDisplayString(_unref(formatWon)(item.platformFee)) + "원", 1),
                                        _createElementVNode("td", _hoisted_70, _toDisplayString(_unref(formatWon)(item.shippingFee)) + "원", 1),
                                        _createElementVNode("td", _hoisted_71, _toDisplayString(_unref(formatWon)(item.payout)) + "원", 1)
                                      ]))
                                    }), 128))
                                  ])
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_72, [
                _createVNode(AppIcon, {
                  icon: "mdi-cash-off",
                  size: 30
                }),
                _createElementVNode("p", null, _toDisplayString(loading.value
                ? '불러오는 중입니다…'
                : view.value === 'eligible'
                  ? '정산할 수 있는 구매확정 건이 없습니다.'
                  : '정산신청내역이 없습니다.'), 1)
              ]))
      ])
    ])
  ]))
}
}

})